module.exports = __webpack_public_path__ + "img/contact-us.e5d4d87e.svg";